import React from "react";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import trans from "../../../utils";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";

export default function ViewOfflineConfig({
	selectedConfig,
	setSelectedConfig,
	data,
}) {
	return (
		<>
			<Popup show={selectedConfig}>
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle headtitle={`${data?.name || ""}`} />
					</Modal.Title>
					<Close
						// eslint-disable-next-line react/style-prop-object
						style="close-32 close"
						close={() => {
							setSelectedConfig(null);
						}}
						img="Close"
					/>
				</Modal.Header>

				<Modal.Body className="modal-body-scrollable">
					<p className="fs-16 fw-700 brand-700 text-uppercase">
						{trans("Configuration Details")}
					</p>
					<div className="row">
						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Project")}
									item={data?.project?.name || "- - - - -"}
								/>
								<PopupBodyItem
									title={trans("Level")}
									item={data?.level?.name || "- - - - -"}
								/>
								{data?.formSchemas?.[0]?.name && (
									<PopupBodyItem
										title={trans("Form")}
										item={data?.formSchemas?.[0]?.name || "- - - - -"}
									/>
								)}
							</div>
						</div>
						<div className="col-lg-6">
							<div className="display-border">
								<PopupBodyItem
									title={trans("Building")}
									item={data?.building?.name || "- - - - -"}
								/>
								<PopupBodyItem
									title={trans("Discipline")}
									item={trans(data?.modules?.[0]?.discipline) || "- - - - -"}
								/>
							</div>
						</div>
					</div>
				</Modal.Body>
			</Popup>
		</>
	);
}
